import { FaArrowDown } from '@react-icons/all-files/fa/FaArrowDown';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import { FaArrowUp } from '@react-icons/all-files/fa/FaArrowUp';
import clsx from 'clsx';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonUnstyled } from '.';
import { LocaleContext } from './rebrand/Layout';

const arrows = {
  up: FaArrowUp,
  down: FaArrowDown,
  left: FaArrowLeft,
  right: FaArrowRight,
};

interface TBtnKeyboardNav extends React.ComponentProps<any> {
  className?: string;
  forwardRef?: any;
  labelSkipTo: string;
  directionArrow: 'up' | 'down' | 'left' | 'right';
}

const BtnKeyboardNav: React.FC<TBtnKeyboardNav> = ({
  className,
  forwardRef,
  labelSkipTo,
  directionArrow,
  ...props
}) => {
  const Arrow = arrows[directionArrow];
  const locale = useContext(LocaleContext);

  return (
    <ButtonUnstyled
      ref={forwardRef}
      className={twMerge(
        clsx(
          'pointer-events-none inline-flex rounded-[50%] bg-white p-8 opacity-0 shadow-[0_2px_4px_rgba(0,0,0,0.12)] focus:pointer-events-auto focus:opacity-100',
          className,
        ),
      )}
      aria-label={
        {
          en: `Skip to ${labelSkipTo}`,
          fr: `Passer à la page ${labelSkipTo}`,
        }[locale]
      }
      {...props}
    >
      <Arrow className="text-blue-alt light:text-primary-200" />
    </ButtonUnstyled>
  );
};

export default BtnKeyboardNav;
